import { render } from "./TheSweatshirts.vue?vue&type=template&id=70398deb&scoped=true"
import script from "./TheSweatshirts.vue?vue&type=script&lang=js"
export * from "./TheSweatshirts.vue?vue&type=script&lang=js"

import "./TheSweatshirts.vue?vue&type=style&index=0&id=70398deb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70398deb"]])

export default __exports__